import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
// import { store } from "../state/store";
import { store } from "../store";
import theme from "../Global/theme";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MainRouter from "../Global/routing/MainRouter";
import "../styles.css";
function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        {/* Applies the dark body background, the self-hosted fonts and the
            :root design tokens app-wide. Previously this was mounted only
            inside LoginPage, so every other route rendered on a white body. */}
        <CssBaseline />
        <BrowserRouter>
          <MainRouter />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
